import $ from 'jquery';

import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};
window.app.modules =  app.modules || {};

import initModulesInScope from "@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};


/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as goToLink from '@elements/go-to-link';
app.goToLink = goToLink.init;

import * as toc from '@elements/toc';
app.toc = toc.init;
app.modules.toc = toc.initInScope;

import * as findologic from './scripts/findologic';
app.modules.findologic = findologic.initInScope;

import * as lazyImg from './scripts/lazy-img';
app.modules.lazyImg = lazyImg.initInScope;

import * as shariff from './scripts/shariff';
app.modules.shariff = shariff.initInScope;

import * as videoJs from './scripts/videoJs';
app.modules.videoJs = videoJs.initInScope;

import * as lightbox from '@elements/lightbox';
app.modules.lightbox = lightbox.initInScope;

import * as summernoteEditor from './scripts/summernote-editor';
app.modules.summernoteEditor = summernoteEditor.initInScope;

import * as menuAim from './scripts/menu-aim';
app.modules.menuAim = menuAim.initInScope;

import * as touchNav from './scripts/touch-nav';
app.modules.touchNav = touchNav.initInScope;
//
// import * as cookieSettings from "./scripts/cookie-settings"
// app.modules.cookieSettings = cookieSettings.init();

import * as nav from './scripts/nav';
app.modules.nav = nav.initInScope;

import * as joeBenefits from './scripts/joeBenefits';
app.modules.joeBenefits = joeBenefits.initInScope;

import * as addPromotion from './scripts/addPromotion';
app.modules.addPromotion = addPromotion.initInScope;

import * as collapsingRadio from './scripts/collapsingRadio';
app.modules.collapsingRadio = collapsingRadio.initInScope;

import * as addressValidation from './scripts/address-validation';
app.modules.addressValidation = addressValidation.initInScope;

import * as swiper from './scripts/swiper';

app.modules.productContentTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-product-content-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 20,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 4,
                spaceBetween: 40
            }
        }
    });

app.modules.contentTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-content-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 40,
                allowTouchMove:false
            }
        }
    });


app.modules.contentTeaserSwiperBig = swiper.createInitInScope({
        sliderContainer: '.js-swiper-content-teaser-big',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        }
    });

app.modules.teaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        }
    });


app.modules.uspsSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-usps',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 2,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 4,
                spaceBetween: 40,
                allowTouchMove:false
            }
        }
    });

app.modules.brandsSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-brands',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: true,
        slidesPerView: 2.4,
        spaceBetween: 20,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 6,
                spaceBetween: 40,
                allowTouchMove:false
            }
        }
    });


app.modules.articleTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-article-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 40,
                allowTouchMove:false
            }
        }
    });

import * as productDetailSwiper from './scripts/product-detail-swiper';
app.modules.productDetailSwiper = productDetailSwiper.initInScope;

import * as imageThumbSwiper from './scripts/image-thumb-swiper';
app.modules.imageThumbSwiper = imageThumbSwiper.initInScope;

import * as productGrid from '@elements/product-grid';
app.productGrid = productGrid.init;
app.modules.productGrid = productGrid.initInScope;

import * as productGridQuickFilter from '@elements/product-grid/quick-filter';
app.modules.productGridQuickFilter = productGridQuickFilter.initInScope;

import * as flugblattSwiper from './scripts/flugblatt-swiper';
app.modules.flugblattSwiper = flugblattSwiper.initInScope;

import * as fileUpload from './scripts/file-upload';
app.modules.fileUpload = fileUpload.initInScope;

import * as overlay from './scripts/overlay';
app.overlay = overlay.init;
app.modules.overlay = overlay.initInScope;

import * as rangeSlider from './scripts/range-slider';
app.modules.rangeSlider = rangeSlider.initInScope;

import * as general from './scripts/general';
app.modules.general = general.initInScope;

import * as showMore from './scripts/show-more';
app.modules.showMore = showMore.initInScope;

import * as myStore from './scripts/my-store';
app.modules.myStore = myStore.initInScope;

import * as applicationForm from './scripts/application-form';
app.modules.applicationForm = applicationForm.initInScope;

import * as cart from './scripts/cart';
app.cart = cart.init;
app.modules.cart = cart.initInScope;

import * as smoothScroll from '@elements/smooth-scroll';
let options = {
    offset: 120
};

smoothScroll.init(options, {});
smoothScroll.initInScope();

import * as numberSpinner from '@elements/number-spinner';
app.modules.numberSpinner = numberSpinner.initInScope;

import * as affix from '@elements/affix';
app.modules.affix = affix.initInScope;


app.modules.navAffix = affix.createInitInScope(
    {
        mediaQuery: '(min-width: 768px)'
    },
    {
        base: '.js-nav-affix',
        placeholder: '.js-affix__placeholder',
        container: '.js-affix__container'

    });

import * as centerActiveTab from './scripts/center-active-tab';
app.modules.centerActiveTab = centerActiveTab.initInScope;

import * as affixNavbar from './scripts/affix-navbar';
app.affixNavbar = affixNavbar.init;


import * as floatingLabel from '@elements/floating-labels';
app.modules.floatingLabel = floatingLabel.initInScope;

import * as loadStoreInfo from './scripts/load-store-info';
app.modules.loadStoreInfo = loadStoreInfo.initInScope;

import * as formAutoSubmit from './scripts/form-auto-submit';
app.modules.formAutoSubmit = formAutoSubmit.initInScope;

import * as optionalRequiredInput from './scripts/optional-required-input';
app.modules.optionalRequiredInput = optionalRequiredInput.initInScope;

import * as geoLocation from './scripts/geolocation';
app.modules.geoLocation = geoLocation.initInScope;


import * as matchmediaViewer from "./scripts/matchmedia-viewer";
app.matchmediaViewer = matchmediaViewer.init;
app.modules.matchmediaViewer = matchmediaViewer.initInScope;

import * as anchorNav from '@elements/anchor-nav';
app.anchorNav  = anchorNav.createInitInScope({
    list: '.js-anchor-nav',
    listItem: '.js-anchor-nav__item'
},  {
    renderItem: function (text, anchor) {
        return '<li class="nav-item anchor-nav__item"><a class="anchor-nav__link nav-link js-smoothscroll__link" href="#' + anchor + '"><span class="anchor-nav__title">' + text + '</span></a></li>';
    },
    smoothScroll: true,
    scrollSpy: true,
    scrollSpyOffset: 300
});


import * as reloadForm from "@elements/reload-form";
app.modules.reloadForm = reloadForm.initInScope;

import * as ajaxForm from '@elements/ajax-form';
app.modules.ajaxForm = ajaxForm.initInScope;

app.modules.checkoutAddressForm = ajaxForm.createInitInScope(undefined, {
    base: '.js-checkout-address-form',
    result: '.js-checkout-address-form__result',
    loading: '.js-checkout-address-form__loading',
    notifications: '.js-checkout-address-form__notifications',
    form: '.js-checkout-address-form__form',
    additionalForm: '.js-checkout-address-form__additional-form',
    errorArea: '.js-checkout-address-form__error-area',
    retry: '.js-checkout-address-form__retry',
    link: '.js-checkout-address-form__link'
});

import * as ajaxFormMap from './scripts/ajax-form-map';
app.modules.ajaxFormMap = ajaxFormMap.initInScope;

import * as ajaxFormScroll from './scripts/ajax-form-scroll';
app.modules.ajaxFormScroll = ajaxFormScroll.initInScope;

import * as googleMap from './scripts/google-map';
app.modules.googleMap = googleMap.initInScope;


import * as radioTabs from './scripts/radio-tabs';
app.modules.radioTabs = radioTabs.initInScope;

// import * as deliveryForm from './scripts/delivery-form';
// app.modules.deliveryForm = deliveryForm.initInScope;

import * as submitFormOnChange from './scripts/submit-form-on-change';
app.modules.submitFormOnChange = submitFormOnChange.initInScope;

import * as newAccountForm from './scripts/new-account-form';
app.modules.newAccountForm = newAccountForm.initInScope;

import * as parsley from '@elements/parsley-bootstrap-validation';
app.modules.parsley = parsley.initInScope;

import * as toggleNavbarMenuOverlay from './scripts/toggle-navbar-menu-overlay';
app.modules.toggleNavbarMenuOverlay = toggleNavbarMenuOverlay.initInScope;

import * as wishlist from './scripts/wishlist';
app.wishlist = wishlist.init;
app.modules.wishlist = wishlist.initInScope;

import * as dateInput from '@elements/date-input';
app.modules.dateInput = dateInput.initInScope;

import * as datepicker from '@elements/datepicker';
app.modules.datepicker = datepicker.initInScope;
app.modules.datepickerChangeYear = datepicker.createInitInScope({
    base: '.js-datepicker-change-year',
    input: '.js-datepicker-change-year__input',
    altField: '.js-datepicker-change-year__alt-field'
}, {
    changeYear: true,
    yearRange: "-100:+0",
    changeMonth: true,
});

import * as datepickerRange from '@elements/datepicker-range';
app.modules.datepickerRange = datepickerRange.initInScope;

import * as fileInput from '@elements/file-input';
app.modules.fileInput = fileInput.initInScope;

import * as recaptcha from './scripts/recaptcha';
app.modules.recaptcha = recaptcha.initInScope;

import * as comparelist from './scripts/compare-list';
app.comparelist = comparelist.init;
app.modules.comparelist = comparelist.initInScope;

import * as toggleToListTooltip from './scripts/toggle-to-list-tooltip';
app.modules.toggleToListTooltip = toggleToListTooltip.createTooltipInitInScope;

import * as renderTemplate from './scripts/render-template';
app.modules.renderTemplate = renderTemplate.initInScope;

import * as manufacturerLibs from './scripts/manufacturer-libs';
app.manufacturerLibs = manufacturerLibs.init;

import * as flugblattHotspots from './scripts/flugblatt-hotspot';
app.modules.flugblattHotspots = flugblattHotspots.initInScope;

import * as popinModal from './scripts/popin-modal';
app.popinModal = popinModal.init;

import * as ratingStars from './scripts/rating-stars';
app.modules.ratingStars = ratingStars.initInScope;

import * as searchBar from './scripts/searchBar';
app.modules.searchBar = searchBar.initInScope;

import * as ajaxModal from './scripts/ajax-modal';
app.modules.ajaxModal = ajaxModal.initInScope;

import * as scrollingTabs from './scripts/scrolling-tabs';
app.modules.scrollingTabs = scrollingTabs.initInScope;

import * as fetchTabs from './scripts/fetch-tabs';
app.modules.fetchTabs = fetchTabs.initInScope;

import * as forgotPassword from './scripts/forgot-password';
app.modules.forgotPassword = forgotPassword.initInScope;

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        // console.log('key',_key)
        // console.log('val',_val)
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);

app.modules.tooltip = ( function (){
    $('.js-tooltip').tooltip();
}());